/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 14 2024
 **/

import { Button, Column, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

interface DisconnectedByOtherDeviceProps {
	onHide: () => void;
}

export default function DisconnectedByOtherDevice(props: DisconnectedByOtherDeviceProps) {
	return (
		<Column horizonAlign="center" gap={14} css={{ padding: "24px" }}>
			<Typography typoSize="Title3">{_T("다른 환경에서 로그인되어 자동 로그아웃 되었습니다.")}</Typography>
			<Button onClick={props.onHide}>{_T("확인")}</Button>
		</Column>
	);
}
